import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-gray-100 rounded-lg px-3 py-4 mt-2" }
const _hoisted_2 = { class: "flex flex-col lg:flex-row md:flex-row justify-between items-center lg:items-start md:items-start" }
const _hoisted_3 = { class: "flex flex-col lg:flex-row md:flex-row items-center space-x-1" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "flex flex-col leading-5 text-center lg:text-left md:text-left lg:mt-0 md:mt-0 mt-2" }
const _hoisted_6 = { class: "text-gray-800 text-lg" }
const _hoisted_7 = { class: "text-sm text-gray-600" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Type: ")
const _hoisted_9 = { class: "text-xs uppercase" }
const _hoisted_10 = { class: "mt-4 lg:mt-0 md:mt-0" }
const _hoisted_11 = ["href"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
  })
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "pl-1" }, "Download", -1)
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", {
            src: _ctx.getFileIcon(_ctx.getFileExtension(_ctx.url)),
            alt: "",
            class: "lg:w-24 lg:h-24 md:w-24 md:h-24 w-16 h-16"
          }, null, 8, _hoisted_4),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.getFileName(_ctx.url)), 1),
            _createElementVNode("span", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("strong", _hoisted_9, _toDisplayString(_ctx.getFileExtension(_ctx.url)), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("a", {
            href: _ctx.url,
            target: "_blank",
            download: "",
            class: "px-4 py-2 text-primary hover:bg-gray-100 text-xs rounded-full border-2 border-primary flex items-center flex-row"
          }, _hoisted_14, 8, _hoisted_11)
        ])
      ])
    ])
  ]))
}